/**
 * User preferences API (improve_model, trial fingerprint bookkeeping).
 */
import { getCurrentUserToken } from './firebase';

const BACKEND_URL = (() => {
  try {
    return (
      import.meta.env.VITE_BACKEND_URL ||
      import.meta.env.VITE_API_URL ||
      'https://pixlie-fastapi-eu-8fb92ba4ec59.herokuapp.com'
    );
  } catch {
    return 'https://pixlie-fastapi-eu-8fb92ba4ec59.herokuapp.com';
  }
})().replace(/\/$/, '');

export type UserPreferences = {
  user_id: string;
  improve_model: boolean;
  plan_tier: string;
  trial_fingerprint?: string | null;
  email_verified?: boolean;
};

export async function fetchUserPreferences(): Promise<UserPreferences | null> {
  const token = await getCurrentUserToken();
  if (!token) return null;
  try {
    const res = await fetch(`${BACKEND_URL}/api/user/preferences`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return null;
    return (await res.json()) as UserPreferences;
  } catch {
    return null;
  }
}

export async function patchUserPreferences(body: {
  improve_model?: boolean;
  trial_fingerprint?: string;
  email_verified?: boolean;
}): Promise<UserPreferences | null> {
  const token = await getCurrentUserToken();
  if (!token) return null;
  try {
    const res = await fetch(`${BACKEND_URL}/api/user/preferences`, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    if (!res.ok) return null;
    return (await res.json()) as UserPreferences;
  } catch {
    return null;
  }
}
